import axios, { AxiosResponse } from "axios";
import environment from "../config";




export async function getAdaMemberDocumentsByParams(
  tokenNum: string
) {

    try {
      const body = {
      tokenNum:tokenNum
      };
      const path = environment.BASE_URL + "Ada/GetAdaMemberDocumentsByParams";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (res.data.documentsArray.length) {
        var response = res.data.documentsArray 
        if (response.length > 1) {
          return response;
        }
      }
      return [];
    } catch (err) {
      console.log(err);
    }
  
  return [];
}

export async function downloadAdaMemberDocument(
  tokenNum: string,
  documentNum?: number,
  isNispach:boolean = false
) {

    try {

      const body = {
          tokenNum: tokenNum,
          documentNum: documentNum,
          isNispach
        };
      const path = environment.BASE_URL + "Ada/DownloadAdaMemberDocument";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (res?.data) {

        return res.data;
      }
      return {};
    } catch (err) {
      console.log(err);
    }
  
  return {};
}



export async function downloadAdaMemberDocumentForViewDoc(
  tokenNum: string,
  isNispach:boolean = false
) {

    try {

      const body = {
          tokenNum: tokenNum,
          isNispach
        };
      const path = environment.BASE_URL + "Ada/downloadAdaMemberDocumentForViewDoc";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (res?.data) {

        return res.data;
      }
      return {};
    } catch (err) {
      console.log(err);
    }
  
  return {};
}


export async function getAdaMemberDocumentsBySourceMenuID(
  tokenNum: string,
  fundCode:number | null,
  documentFromDate: string,
  sourceMenuId: number
) {

    try {
      const body = {
        tokenNum: tokenNum,
        fundCode: fundCode,
        documentFromDate: documentFromDate,
        sourceMenuId: sourceMenuId

      };
      const path = environment.BASE_URL + "Ada/GetAdaMemberDocumentsBySourceMenuID";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (res?.data) {

        return res.data.documentsArray;
      }
      return {};
    } catch (err) {
      console.log(err);
    }
  
  return {};
}

